<template>
  <v-card class="pa-3 ma-0">
    <transition name="fade" mode="out-in">
      <main v-if="!details && !editViews && !editPrinter && !addImage && !editAllergens">
        <v-layout row justify-space-between>
          <h2>{{ currentItemEvent === 'edit' ? $lang.header.edit : $lang.header.add }} {{ $lang.header.item }}</h2>
          <v-btn flat fab small type="button" class="ma-0" data-dismiss="modal" @click="$emit('close')"
                 aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-alert :value="true" type="error" v-if="err"> {{err}}</v-alert>
        <v-layout row wrap justify-space-between>
          <v-flex xs12 sm9>
            <v-layout row wrap justify-space-between>
              <v-flex xs12 sm4 pa-2 class="vat">
                <v-select
                    :label="$lang.header.vat"
                    :items="vatItems"
                    class="pt-0 mt-2 max-w"
                    :disabled="!this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0"
                    v-model="vatRate"
                    hide-details
                />
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.views }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="selectedViews.length === 0" @click="editViewsToggle">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editViewsToggle">edit</v-icon>
                </v-layout>
                <div class="views mt-2 p-3" v-if="selectedViews.length > 0">
                  <template v-for="(view, index) in views"
                            v-if="selectedViews.indexOf(view.viewId !== -1) && selectedViews[selectedViews.indexOf(view.viewId)] === view.viewId">
                    <p :key="index">{{view.name[language]}}, </p>
                  </template>
                </div>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row wrap align-center>
                  <h3 class="mr-3">{{ $lang.header.printerCategories }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="selectedPrinters.length === 0" @click="editPrinterToggle()">
                    add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editPrinterToggle()">edit</v-icon>
                </v-layout>
                <div class="views mt-2 p-3" v-if="selectedPrinters.length > 0 || inheritSelectedPrinters.length > 0">
                  <template v-for="(category, index) in selectedPrinters">
                    <p :key="index">{{category}}, </p>
                  </template>
                  <template v-for="(printer, index2) in inheritSelectedPrinters">
                    <p :key="'I-'+index2" style="color: blue !important;">{{printer}}, </p>
                  </template>
                </div>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.abbreviation }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="abbr === null" @click="openDetails('Abbreviation', 'abbr')">
                    add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Abbreviation', 'abbr')">edit</v-icon>
                </v-layout>
                <ul v-if="abbr !== null">
                  <li v-for="(lang, index) in languages" :key="index" v-if="abbr && abbr.name[lang.value]">
                <span class="d-inline-block light-text">
                  [{{lang.text}}]
                </span>
                    {{abbr.name[lang.value]}}
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.name }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="name === null" @click="openDetails('Name', 'name')">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Name', 'name')">edit</v-icon>
                </v-layout>
                <ul class="mt-2" v-if="name !== null">
                  <li v-if="name && name.name[lang.value]" v-for="(lang, index) in languages" :key="index">
                <span class="d-inline-block light-text">
                  [{{lang.text}}]
                </span>
                    {{name.name[lang.value]}}
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.description }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="desc === null" @click="openDetails('Description', 'desc')">
                    add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Description', 'desc')">edit</v-icon>
                </v-layout>
                <ul class="mt-2" v-if="desc !== null">
                  <li v-if="desc && desc.name[lang.value]" v-for="(lang, index) in languages" :key="index">
                <span class="d-inline-block light-text">
                  [{{lang.text}}]
                </span>
                    {{desc.name[lang.value]}}
                  </li>
                </ul>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.sizes }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="sizes.length === 0" @click="openDetails('Sizes', 'sizes')">
                    add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Sizes', 'sizes')">edit</v-icon>
                  <v-icon class="my-0 d-inline-block" v-if="sizes.length > 0" @click="removeDefaults(sizes)">
                    turned_in_not
                  </v-icon>
                </v-layout>
                <template v-if="sizes.length !== 0" v-for="(size, index) in sizes">
                  <ul class="mt-2 pt-2 underline" :key="index">
                    <li v-if="size.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      {{size.name[lang.value]}}
                      {{size.price}}
                      <span class="d-inline-block light-text" v-if="size.isDefault">
                    &#60;{{$lang.labels.default}}&#62;
                  </span>
                      <span class="arrow_to_move" v-if="sizes.length > 1">
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemUp('sizes', index)">keyboard_arrow_up</i>
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemDown('sizes', index)">keyboard_arrow_down</i>
                  </span>
                    </li>
                  </ul>
                </template>
                <template v-if="inheritSelectedAttributes.sizes !== 0" v-for="(size, index) in inheritSelectedAttributes.sizes">
                  <ul class="mt-2 pt-2 underline" :key="'inhSize-'+index">
                    <li v-if="size.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      <span style="color: blue !important;">{{size.name[lang.value]}}
                        {{size.price}}</span>
                    </li>
                  </ul>
                </template>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.options }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="options.length === 0"
                          @click="openDetails('Options', 'options')">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Options', 'options')">edit</v-icon>
                  <v-icon class="my-0 d-inline-block" v-if="options.length > 0" @click="removeDefaults(options)">
                    turned_in_not
                  </v-icon>
                </v-layout>
                <div class="d-inline-flex" style="max-height: 25px">
                  <span style="margin-top: 13px">{{$lang.labels.quantityOfIncludedOptions}}:</span>
                    <v-text-field
                      style="max-width: 100px"
                      type="number"
                      solo
                      flat
                      min="0"
                      v-model="quantityOfIncludedOptions">
                    </v-text-field>
                </div>
                <template v-if="options.length !== 0" v-for="(option, index) in options">
                  <ul class="mt-2 pt-2 underline" :key="index">
                    <li v-if="option.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      {{option.name[lang.value]}}
                      {{option.price}}
                      <span class="d-inline-block light-text">
                        (max: {{option.maxIncludedQuantity}})
                      </span>
                      <span class="d-inline-block light-text" v-if="option.isDefault">
                        &#60;{{$lang.labels.default}}&#62;
                      </span>
                      <span class="arrow_to_move" v-if="options.length > 1">
                        <i class="material-icons pointerClass" @click.stop.prevent="moveItemUp('options', index)">keyboard_arrow_up</i>
                        <i class="material-icons pointerClass" @click.stop.prevent="moveItemDown('options', index)">keyboard_arrow_down</i>
                      </span>
                    </li>
                  </ul>
                </template>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.allergens }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="selectedAllergens.length === 0"
                          @click="editAllergensToggle">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editAllergensToggle">edit</v-icon>
                </v-layout>
                <div class="views mt-2 p-3" v-if="selectedAllergens.length > 0">
                  <template v-for="(allergen, index) in allergens"
                            v-if="selectedAllergens.indexOf(allergen.allergenId !== -1) && selectedAllergens[selectedAllergens.indexOf(allergen.allergenId)] === allergen.allergenId">
                    <p :key="index">{{allergen.name[language]}}, </p>
                  </template>
                </div>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.styles }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="styles.length === 0"
                          @click="openDetails('Styles', 'styles')">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Styles', 'styles')">edit</v-icon>
                  <v-icon class="my-0 d-inline-block" v-if="styles.length > 0" @click="removeDefaults(styles)">
                    turned_in_not
                  </v-icon>
                </v-layout>
                <template v-if="styles.length !== 0" v-for="(style, index) in styles">
                  <ul class="mt-2 pt-2 underline" :key="index">
                    <li v-if="style.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      {{style.name[lang.value]}}
                      <span class="d-inline-block light-text" v-if="style.isDefault">
                    &#60;{{$lang.labels.default}}&#62;
                  </span>
                      <span class="arrow_to_move" v-if="styles.length > 1">
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemUp('styles', index)">keyboard_arrow_up</i>
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemDown('styles', index)">keyboard_arrow_down</i>
                  </span>
                    </li>
                  </ul>
                </template>
                <template v-if="inheritSelectedAttributes.styles !== 0" v-for="(style, index) in inheritSelectedAttributes.styles">
                  <ul class="mt-2 pt-2 underline" :key="'inhStyle-'+index">
                    <li v-if="style.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      <span style="color: blue !important;">{{style.name[lang.value]}}
                        {{style.price}}</span>
                    </li>
                  </ul>
                </template>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <v-layout row align-center wrap>
                  <h3 class="mr-3">{{ $lang.header.variants }}</h3>
                  <v-icon class="my-0 d-inline-block" v-if="variants.length === 0"
                          @click="openDetails('Variants', 'variants')">add
                  </v-icon>
                  <v-icon class="my-0 d-inline-block" v-else @click="editItem('Variants', 'variants')">edit</v-icon>
                  <v-icon class="my-0 d-inline-block" v-if="variants.length > 0" @click="removeDefaults(variants)">
                    turned_in_not
                  </v-icon>
                </v-layout>
                <template v-if="variants.length !== 0" v-for="(variant, index) in variants">
                  <ul class="mt-2 pt-2 underline" :key="index">
                    <li v-if="variant.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      {{variant.name[lang.value]}}
                      {{variant.price}}
                      <span class="d-inline-block light-text" v-if="variant.isDefault">
                    &#60;{{$lang.labels.default}}&#62;
                  </span>
                      <span class="arrow_to_move" v-if="variants.length > 1">
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemUp('variants', index)">keyboard_arrow_up</i>
                    <i class="material-icons pointerClass" @click.stop.prevent="moveItemDown('variants', index)">keyboard_arrow_down</i>
                  </span>
                    </li>
                  </ul>
                </template>
                <template v-if="inheritSelectedAttributes.variants !== 0" v-for="(variant, index) in inheritSelectedAttributes.variants">
                  <ul class="mt-2 pt-2 underline" :key="'inhStyle-'+index">
                    <li v-if="variant.name[lang.value]" v-for="(lang, langIndex) in languages" :key="langIndex">
                  <span class="d-inline-block light-text">
                    [{{lang.text}}]
                  </span>
                      <span style="color: blue !important;">{{variant.name[lang.value]}}
                        {{variant.price}}</span>
                    </li>
                  </ul>
                </template>
              </v-flex>

              <v-flex xs12 sm4 pa-2 class="checkbox-wrap">
                <h3 class="mb-2">{{ $lang.header.settings }}</h3>
                <v-checkbox color="primary" v-model="labelPrint" :label="$lang.labels.labelPrint" hide-details/>
                <v-checkbox color="primary" v-model="askDetails" :label="$lang.labels.askDetails" hide-details/>
                <v-checkbox color="primary" v-model="vatPrint" :label="$lang.labels.vatPrint" hide-details/>
                <v-checkbox color="primary" v-model="noDiscount" :label="$lang.labels.noDiscount" hide-details/>
                <v-checkbox color="primary" v-model="galaxyCardBalance" :label="$lang.labels.addsGalaxyCardBalance" hide-details/>
              </v-flex>

              <v-flex xs12 sm4 pa-2>
                <h3>{{ $lang.header.color }}</h3>
                <v-layout align-center row class="mb-4">
                <span
                  v-if="color"
                  class="color-preview mr-3"
                  :style="{ 'background-color': color }"></span>
                  <v-combobox
                      :label="$lang.header.color"
                      class="min-w"
                      :items="colors"
                      :search-input.sync="color"
                      v-model="color"
                      hide-details>
                    <v-list-tile-content slot="item" slot-scope="data">
                      <v-layout row align-center justify-center style="width: 100%;">
                        <div class="shrink mr-2">{{ data.item }}</div>
                        <v-flex
                            :style="{'background-color': data.item }"
                            grow
                            class="list-color-preview"
                        />
                      </v-layout>
                    </v-list-tile-content>
                  </v-combobox>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4 pa-2>
                <h3>{{ $lang.header.taxCategory }}</h3>
                <v-layout align-center row>
                  <v-combobox
                    :items="taxCategories"
                    v-model="taxCategory"
                    @input.native="e => taxCategory = e.target.value"
                  >
                  </v-combobox>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm4 pa-2>
                <h3>{{ $lang.header.courseNo }}</h3>
                <v-text-field
                  type="number"
                  min="1"
                  max="6"
                  :rules="[(v) => v > 0 && v < 7 || 'Error']"
                  v-model="courseNo"
                  :label="$lang.header.courseNo">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm3>
            <v-layout row wrap fill-height align-start py-2>
              <h3 class="mr-3">{{ $lang.header.images }}</h3>
              <v-icon class="my-0 d-inline-block" @click="openAddImage()">
                add
              </v-icon>
              <v-flex xs12 style="height: 45%; overflow-y: auto">
                <v-list v-if="images.length > 0">
                  <template v-for="(image, index) in filteredAddedImages">
                    <v-list-tile
                        dense="true"
                        :key="image.id"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ image.label }}</v-list-tile-title>
                        <v-list-tile-sub-title class="text--primary">{{ image.name }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                      <v-list-tile-action>
                        <div class="my-0 d-inline-block">
                          <v-btn
                              color="primary"
                              class="mx-0"
                              @click="preview(image.base64Image)">
                            {{ $lang.actions.preview }}
                          </v-btn>
                          <v-btn
                              dark
                              icon
                              color="red"
                              class="mx-0"
                              @click="deleteImg(index)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </div>
                      </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < items.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </v-flex>
              <v-flex xs12 style="height: 45%">
                <v-img v-if="previewImage !== ''" :src="previewImage" contain
                       style="max-height: 200px !important;"></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout row justify-start align-end>
          <v-btn color="blue" dark class="mx-1" @click="submitItem(true)">{{ $lang.actions.copy }}</v-btn>
          <v-btn color="blue" dark class="mx-1" @click="paste()">{{ $lang.actions.paste }}</v-btn>
          <v-btn color="blue" dark class="mx-1 ml-5" @click="plusOneFunct()">{{ $lang.actions.importFromParent }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mx-0" @click="submitItem()">{{ $lang.actions.submit }}</v-btn>
        </v-layout>
      </main>
    </transition>
    <transition name="fade" mode="out-in">
      <div v-if="details">
        <v-layout row justify-space-between align-center>
          <h2>{{ $lang.actions.edit }} {{currentLabel}}</h2>
          <v-btn flat fab small type="button" class="ma-0" data-dismiss="modal" @click="closeEdit()" aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-alert :value="true" type="error" v-if="err"> {{err}}</v-alert>
        <div v-if="hasMultiple">
          <div class="single-item mb-3" v-for="(edit, index) in currentEdit" :key="index">
            <div class="v-table__overflow">
              <table class="v-datatable v-table theme--light">
                <thead>
                <tr>
                  <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.language }}</th>
                  <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.name }}</th>
                  <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.default }}</th>
                  <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.actions }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index2) in edit.names" :key="index2">
                  <td>{{item.language}}</td>
                  <td>
                    <v-text-field
                        type="text"
                        :value="item.name"
                        v-model="item.name"
                        @blur="item.name = item.name.trim()">
                    </v-text-field>
                  </td>
                  <td>
                    <p class="default-item" v-if="currentEdit[index].isDefault && currentLabel !== 'Options'">{{ $lang.actions.yes }}</p>
                    <v-checkbox
                      v-else
                      class="pt-3"
                      color="primary"
                      v-model="currentEdit[index].isDefault"
                      :label="$lang.labels.isDefault">
                    </v-checkbox>
                  </td>
                  <td>
                    <v-btn
                        v-if="!currentEdit[index].isDefault && currentLabel !== 'Options'"
                        color="primary"
                        fab
                        small
                        @click="setEditToDefault(index, item)">
                      <v-icon>turned_in</v-icon>
                    </v-btn>
                    <v-btn
                        v-if="currentEdit[index].isDefault && currentLabel !== 'Options'"
                        fab
                        small>
                      <v-icon>turned_in_not</v-icon>
                    </v-btn>
                    <v-btn
                        fab
                        small
                        color="error"
                        @click="removeLang(index, index2)">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <v-layout row justify-space-between align-center>
              <div class="text-xs-center" v-if="edit.languages.length > 0">
                <v-menu>
                  <v-btn
                      outline
                      flat
                      class="mx-0"
                      slot="activator"
                      type="button">
                    {{ $lang.actions.addlanguage }}
                    <v-icon>keyboard_arrow_down</v-icon>
                  </v-btn>
                  <v-list>
                    <v-list-tile
                        class="dropdown-item"
                        v-for="(lang, langIndex) in edit.languages"
                        :key="langIndex"
                        @click="addEditLang(lang.value, langIndex, index)">
                      <v-list-tile-title>
                        {{lang.text}}
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>
              <v-btn
                  class="mx-0"
                  color="error"
                  @click="removeEdit(index)">
                {{ $lang.actions.deleteitem }}
              </v-btn>
            </v-layout>
            <v-layout row align-center>
            <v-flex xs2 pr-2 v-if="hasPrice">
              <v-text-field
                  type="number"
                  v-model="edit.price"
                  label="Price">
              </v-text-field>
            </v-flex>
              <v-flex xs2 pl-2 v-if="currentLabel === 'Options'">
                <v-text-field
                  type="number"
                  min="0"
                  :max="quantityOfIncludedOptions"
                  :rules="[value => value <= quantityOfIncludedOptions || 'Must not be higher than Quantity Of Included Options!']"
                  v-model="edit.maxIncludedQuantity"
                  :label="`${$lang.labels.includedQuantity} (max ${quantityOfIncludedOptions})`">
                </v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </div>
        <div class="v-table__overflow" v-else>
          <table class="v-datatable v-table theme--light">
            <thead>
            <tr>
              <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.language }}</th>
              <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.name }}</th>
              <th role="columnheader" scope="col" class="column text-xs-left">{{ $lang.header.actions }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in currentEdit[0].names" :key="index">
              <td>{{item.language}}</td>
              <td>
                <v-text-field
                    type="text"
                    :value="item.name"
                    v-model="item.name"
                    @blur="item.name = item.name.trim()">
                </v-text-field>
              </td>
              <td>
                <v-btn
                    color="error"
                    fab
                    small
                    @click="removeLang(0, index)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <v-layout row justify-end>
          <v-btn
              color="primary"
              fab
              outline
              small
              @click="addEdit()"
              v-if="hasMultiple">
            <v-icon>add</v-icon>
          </v-btn>
          <div
              class="text-xs-center"
              v-if="!hasMultiple && currentEdit[0].languages.length > 0">
            <v-menu>
              <v-btn
                  outline
                  flat
                  slot="activator"
                  type="button">
                {{ $lang.actions.addlanguage }}
                <v-icon>keyboard_arrow_down</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                    v-for="(lang, index) in currentEdit[0].languages"
                    :key="index"
                    @click="addEditLang(lang.value, index)">
                  <v-list-tile-title>
                    {{lang.text}}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </div>
          <v-btn color="primary" class="mx-0" @click="submitEdit()">{{ $lang.actions.submit }}</v-btn>
        </v-layout>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="description" v-if="editViews">
        <v-layout row align-center justify-space-between>
          <h2>{{ $lang.actions.editViews }}</h2>
          <v-btn flat fab small type="button" class="ma-0" data-dismiss="modal" @click="closeViews()"
                 aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout row align-center class="checkbox-wrap my-4">
          <v-checkbox
              v-for="(view, index) in catalogViews"
              :key="index"
              color="primary"
              v-model="view.selected"
              @change="$forceUpdate()"
              :label="view.name[language]">
          </v-checkbox>
        </v-layout>
        <v-layout row justify-end>
          <v-btn color="primary" class="mx-0" @click="submitViews()">{{ $lang.actions.submit }}</v-btn>
        </v-layout>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="description" v-if="editAllergens">
        <v-layout row align-center justify-space-between>
          <h2>{{ $lang.actions.editAllergens }}</h2>
          <v-btn flat fab small type="button" class="ma-0" data-dismiss="modal" @click="closeAllergens()"
                 aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout wrap row align-center class="checkbox-wrap my-4">
          <template v-for="(allergen, index) in catalogAllergens">
            <v-flex xs12>
              <v-checkbox
                :key="index"
                color="primary"
                v-model="allergen.selected"
                @change="$forceUpdate()"
                :label="allergen.name[language]">
              </v-checkbox>
            </v-flex>
          </template>
        </v-layout>
        <v-layout row justify-end>
          <v-btn color="primary" class="mx-0" @click="submitAllergens()">{{ $lang.actions.submit }}</v-btn>
        </v-layout>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="description" v-if="editPrinter">
        <v-layout row justify-space-between align-center>
          <h2>{{ $lang.actions.editPrinterCategories }}</h2>
          <v-btn flat small fab type="button" class="ma-0" data-dismiss="modal" @click="closePrinter()"
                 aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout row wrap class="checkbox-wrap my-4">
          <v-checkbox
              v-for="(printerCategory, index) in catalogPrinters"
              :key="index"
              color="primary"
              :disabled="index === 0"
              v-model="printerCategory.selected"
              @change="$forceUpdate()"
              :label="printerCategory.name">
          </v-checkbox>
        </v-layout>
        <v-layout row justify-end>
          <v-btn color="primary" class="mx-0" @click="submitPrinters()">{{ $lang.actions.submit }}</v-btn>
        </v-layout>
      </div>
    </transition>

    <transition name="fade" mode="out-in">
      <div class="description" v-if="addImage">
        <v-alert :value="true" type="error" v-if="errImage"> {{errImage}}</v-alert>
        <v-layout row align-center justify-space-between>
          <h2>{{ $lang.actions.addImage1 }}</h2>
          <v-btn flat fab small type="button" class="ma-0" data-dismiss="modal" @click="addImage = false"
                 aria-label="Close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm4 pa-2>
            <v-select :items="labels"
                      :label="$lang.labels.choseLabelToAddImage"
                      v-model="selectedLabel"
                      @input="selectedImage = {}"
            />
          </v-flex>
          <v-flex xs12 sm4 pa-2>
            <v-autocomplete
                :loading="loading"
                :label="selectedLabel === '' ? $lang.labels.selectLabelFirst : $lang.labels.selectImage"
                :items="filteredImages"
                item-text="name"
                item-value="id"
                v-model="selectedImageId"
                hide-details
                @input="fetchImageById()"
            />
          </v-flex>
          <v-flex xs12 sm4 pa-2 style="height: 200px">
            <v-progress-circular color="primary" indeterminate v-if="loadingPreview"></v-progress-circular>
            <v-img v-if="selectedImage.base64Image" :src="selectedImage.base64Image" contain
                   style="max-height: 180px  !important;"></v-img>
          </v-flex>
        </v-layout>
        <v-layout row justify-end>
          <v-btn :disabled="!selectedImage.base64Image" color="primary" class="mx-0" @click="submitAddImage()">{{ $lang.actions.submit }}
          </v-btn>
        </v-layout>
      </div>
    </transition>
  </v-card>
</template>

<script>
  import Vue from 'vue';

  export default {
    props: ['views', 'allergens', 'items', 'maxItemId', 'currentItemEvent', 'actionPath', 'selectedCompanyInfo', 'copyData', 'taxCategories', 'plusOne'],
    data() {
      return {
        pickedItem: null,
        err: '',
        errImage: '',
        details: false,
        editViews: false,
        editAllergens: false,
        editPrinter: false,
        isItemChild: false,
        addImage: false,
        currentItemParent: null,
        abbr: null,
        name: null,
        desc: null,
        sizes: [],
        options: [],
        styles: [],
        itemId: null,
        variants: [],
        selectedViews: [],
        selectedAllergens: [],
        catalogViews: [],
        catalogAllergens: [],
        catalogPrinters: [],
        viewsInEdit: [],
        vatRate: null,
        currentLabel: null,
        currentTarget: null,
        hasPrice: false,
        hasMultiple: false,
        isDefault: false,
        labelPrint: false,
        vatPrint: false,
        noDiscount: false,
        quantityOfIncludedOptions: 0,
        galaxyCardBalance: false,
        askDetails: false,
        language: this.$cookie.get('lang') || 'en',
        languages: JSON.parse(localStorage.languages),
        pricedItems: [
          'sizes',
          'options',
          'variants',
        ],
        multipleItems: [
          'sizes',
          'options',
          'variants',
          'styles',
        ],
        currentEdit: [
          {
            names: [
              {
                language: this.$cookie.get('lang') || 'en',
                name: '',
              },
            ],
            languages: JSON.parse(localStorage.languages),
            price: '',
            isDefault: false,
            maxIncludedQuantity: 0,
          },
        ],
        selectedPrinters: [],
        printerCategories: [
          'LABEL',
          'KITCHEN1',
          'KITCHEN2',
          'KITCHEN3',
          'KITCHEN4',
          'KITCHEN5',
          'BAR1',
          'BAR2',
          'BAR3',
          'BAR4',
          'BAR5',
          'SALAD1',
          'SALAD2',
          'SALAD3',
          'SALAD4',
          'SALAD5',
        ],
        colors: [
          "#FFFFFF",
          "#D3d3d3",
          "#84A3B1",
          "#66BFFE",
          "#459DF2",
          "#FFC33F",
          "#7CF56E",
          "#FBF068",
          "#F7E7A6",
          "#FFC6C2",
          "#C98986",
          "#F6E4F6",
          "#C490D1",
          "#A0D2DB",
          "#B8336A",
          "#9348FA",
          "#F36F68",
          "#79B561",
          "#BC8F8F",
          "#FFE4e1",
          "#E9967A",
          "#D2691E",
          "#FFDAB9",
          "#F3D170",
          "#BDB76B",
          "#9aCd32",
          "#F0FFF0",
          "#98FB98",
          "#8FBC8F",
          "#32Cd32",
          "#3CB371",
          "#66Cdaa",
          "#40E0d0",
          "#E0FFFF",
          "#b0E0E6",
          "#87CeFa",
          "#4682B4",
          "#708090",
          "#E6e6Fa",
          "#ba55d3",
          "#EE82EE",
          "#FF69B4",
          "#DB7093",
          "#FFF0F5",
          "#FFC0Cb",
          "#CD853F",
        ],
        color: null,
        taxCategory: 'standard',
        inheritSelectedPrinters: [],
        allImages: [],
        images: [],
        basicImages: [],
        selectedImage: {},
        selectedImageId: '',
        labels: [],
        selectedLabel: '',
        loading: false,
        loadingPreview: false,
        previewImage: '',
        inheritSelectedAttributes: {
          sizes: [],
          styles: [],
          variants: [],
        },
        courseNo: 6,
      };
    },
    computed: {
      filteredImages() {
        return this.allImages.filter(image => image.label === this.selectedLabel).sort((a, b) => (a.name > b.name) ? 1 : -1);
      },
      filteredAddedImages() {
        return this.images.sort((a,b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
      },
      vatItems() {
        return this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0 ?
          [{
            text: 'Not selected',
            value: null
          }, ...this.selectedCompanyInfo.vatRates.map(vatRateItem => ({
            text: `${ vatRateItem }`,
            value: `${ vatRateItem }`
          }))] :
          [{value: 'null', text: 'null'}];
      },
      isVatRateNotExist() {
        if (this.selectedCompanyInfo.vatRates &&
          this.selectedCompanyInfo.vatRates.length !== 0) {
          const vat = this.vatRate.toString();
          return !this.selectedCompanyInfo.vatRates.includes(Number(vat));
        }
      },
    },
    methods: {
      arraymove(arr, fromIndex, toIndex) {
        let element = arr[fromIndex];
        arr.splice(fromIndex, 1);
        arr.splice(toIndex, 0, element);
      },
      moveItemUp(type, index) {
        if (index === 0) {
          return;
        }
        let indexFrom = index;
        let indexTo = index - 1;
        this.arraymove(this[type], indexFrom, indexTo)
      },
      moveItemDown(type, index) {
        if (index === this[type].length - 1) {
          return;
        }
        let indexFrom = index;
        let indexTo = index + 1;
        this.arraymove(this[type], indexFrom, indexTo)
      },
      paste() {
        if (!this.copyData && !localStorage.copyItemData) return;
        let copy = {};
        if (localStorage.copyItemData) {
          copy = JSON.parse(localStorage.copyItemData);
        } else {
          copy = JSON.parse(JSON.stringify(this.copyData));
        }
        if (copy.abbr) {
          this.abbr = {};
          this.abbr.name = copy.abbr;
        }
        if (copy.name) {
          this.name = {};
          this.name.name = copy.name;
        }
        if (copy.desc) {
          this.desc = {};
          this.desc.name = copy.desc;
        }
        this.sizes = copy.sizes || this.sizes;
        this.options = copy.options || this.options;
        this.styles = copy.styles || this.styles;
        this.variants = copy.variants || this.variants;
        // Add only views that exists in catalog
        const viewsIDs = this.views.map(x => x.viewId) || [];
        this.selectedViews = copy.views.filter(x => viewsIDs.includes(x)) || this.selectedViews.filter(x => viewsIDs.includes(x));
        // Add only allergens that exists in catalog
        const allergensIDs = this.allergens.map(x => x.allergenId) || [];
        this.selectedAllergens = copy.allergens.filter(x => allergensIDs.includes(x)) || this.selectedAllergens.filter(x => allergensIDs.includes(x));
        this.selectedPrinters = copy.printerCategories || this.selectedPrinters;
        this.vatRate = copy.vatRate || this.vatRate;
        this.labelPrint = copy.settings.labelPrint;
        this.vatPrint = copy.vatPrint;
        this.noDiscount = copy.noDiscount;
        this.galaxyCardBalance = copy.galaxyCardBalance;
        this.askDetails = copy.settings.askDetails;
        this.currentItemParent = copy.parentItem || this.currentItemParent;
        this.color = copy.colorCode || this.color;
        this.taxCategory = copy.taxCategory || this.taxCategory;
        this.courseNo = Number(copy.courseNo) || this.courseNo;
        this.quantityOfIncludedOptions = copy.quantityOfIncludedOptions || this.quantityOfIncludedOptions;
      },
      removeDefaults(data) {
        data.forEach(obj => this.$set(obj, 'isDefault', false));
      },
      openDetails(label, target) {
        this.currentLabel = label;
        this.currentTarget = target;
        this.hasPrice = this.pricedItems.includes(target);
        this.hasMultiple = this.multipleItems.includes(target);
        this.currentEdit[0].languages = this.currentEdit[0].languages.filter(x => x.value !== this.currentEdit[0].names[0].language);
        this.details = true;
      },
      openAddImage() {
        this.addImage = true;
        this.fetchImagesForCompany();
      },
      deleteImg(index) {
        this.images.splice(index, 1);
      },
      submitAddImage() {
        this.errImage = '';
        if (this.images.filter(image => image.id === this.selectedImage.id).length > 0) {
          this.errImage = 'This image is already added.';
          return;
        }
        this.images.push(this.selectedImage);
        this.selectedImage = {};
        this.selectedLabel = '';
        this.selectedImageId = '';
        this.addImage = false;
      },
      addEditLang(lang, langIndex, index) {
        const editIndex = this.hasMultiple ? index : 0;
        this.currentEdit[editIndex].names.push({
          language: lang,
          name: '',
        });
        this.currentEdit[editIndex].languages.splice(langIndex, 1);
      },
      removeEdit(index) {
        this.currentEdit.splice(index, 1);
      },
      removeLang(index, langIndex) {
        const name = this.currentEdit[index].names[langIndex].language;
        this.currentEdit[index].names.splice(langIndex, 1);
        this.currentEdit[index].languages.push(this.languages.filter(x => x.value === name)[0]);
      },
      setEditToDefault(index, item) {
        this.currentEdit.forEach((item) => {
          item.isDefault = false
        })
        this.currentEdit[index]['isDefault'] = true;
      },
      addEdit() {
        this.currentEdit.push({
          names: [
            {
              language: this.$cookie.get('lang') || 'en',
              name: '',
            },
          ],
          languages: JSON.parse(localStorage.languages),
          price: '',
          isDefault: false
        });
      },
      editPrinterToggle() {
        this.catalogPrinters = this.catalogPrinters.map((current) => {
          let found = false;
          this.selectedPrinters.forEach((printer) => {
            if (current.name === printer) {
              found = true;
            }
          });
          const printer = current;
          printer.selected = found;
          return printer;
        });
        this.editPrinter = true;
      },
      editViewsToggle() {
        this.catalogViews = this.catalogViews.map((current, index) => {
          let found = false;
          //Views by index
          // this.selectedViews.forEach((i) => {
          //   if (index === i) {
          //     found = true;
          //   }
          // });
          //Views by Ids
          this.selectedViews.forEach((i) => {
            if (current.viewId === i) {
              found = true;
            }
          });
          const view = current;
          view.selected = found;
          return view;
        });
        this.editViews = true;
      },
      editAllergensToggle() {
        this.catalogAllergens = this.catalogAllergens.map((current, index) => {
          let found = false;
          this.selectedAllergens.forEach((i) => {
            if (current.allergenId === i) {
              found = true;
            }
          });
          const allergen = current;
          allergen.selected = found;
          return allergen;
        });
        this.editAllergens = true;
      },
      closePrinter() {
        this.catalogPrinters = this.catalogPrinters.map((current) => {
          const printer = current;
          printer.selected = false;
          return printer;
        });
        this.editPrinter = false;
      },
      closeViews() {
        this.catalogViews = this.catalogViews.map((current) => {
          const view = current;
          view.selected = false;
          return view;
        });
        this.editViews = false;
      },
      closeAllergens() {
        this.catalogAllergens = this.catalogAllergens.map((current) => {
          const allergen = current;
          allergen.selected = false;
          return allergen;
        });
        this.editAllergens = false;
      },
      closeEdit() {
        this.err = '';
        this.currentEdit = [
          {
            names: [
              {
                language: this.$cookie.get('lang') || 'en',
                name: '',
              },
            ],
            languages: JSON.parse(localStorage.languages),
            price: '',
            isDefault: false
          },
        ];
        this.details = false;
      },
      submitAllergens() {
        const allergens = [];
        this.catalogAllergens.forEach((allergen, index) => {
          if (allergen.selected) {
            allergens.push(allergen.allergenId);
          }
        });
        this.selectedAllergens = allergens;
        this.editAllergens = false;
      },
      submitViews() {
        const views = [];
        this.catalogViews.forEach((view, index) => {
          //Views by indexes
          // if (view.selected) {
          //   views.push(index);
          // }
          //Views by Ids
          if (view.selected) {
            views.push(view.viewId);
          }
        });
        this.selectedViews = views;
        this.editViews = false;
      },
      submitPrinters() {
        const printers = [];
        this.catalogPrinters.forEach((printer) => {
          if (printer.selected) {
            printers.push(printer.name);
          }
        });
        this.selectedPrinters = printers;
        this.editPrinter = false;
        this.getAllParentPrinters();
      },
      editItem(label, target) {
        this.currentLabel = label;
        this.currentTarget = target;
        this.hasPrice = this.pricedItems.includes(target);
        this.hasMultiple = this.multipleItems.includes(target);
        if (this.hasMultiple) {
          const edits = [];
          this[target].forEach((entry) => {
            const langs = Object.keys(entry.name);
            const foundLangs = [];
            const names = [];
            const edit = {};
            langs.forEach((lang) => {
              const name = {
                language: lang,
                name: entry.name[lang],
              };
              names.push(name);
              this.languages.forEach((available, index) => {
                if (available.value === lang) {
                  foundLangs.push(index);
                }
              });
            });
            Object.assign(edit, {names});
            const editLangs = this.languages.filter((lang, index) => {
              let found = false;
              foundLangs.forEach((i) => {
                if (index === i) {
                  found = true;
                }
              });
              if (!found) {
                return lang;
              }
              return false;
            });
            Object.assign(edit, {languages: editLangs});
            if (this.hasPrice) {
              Object.assign(edit, {price: entry.price});
            }
              if (entry.isDefault) {
                Object.assign(edit, {isDefault: entry.isDefault})
              } else {
                Object.assign(edit, {isDefault: false})
              }
            if (label === 'Options') {
              Object.assign(edit, {maxIncludedQuantity: Number(entry.maxIncludedQuantity) || 0});
            }
            edits.push(edit);
          });
          this.currentEdit = edits;
        } else {
          const entry = this[target];
          const langs = Object.keys(entry.name);
          const foundLangs = [];
          const names = [];
          const edit = {};
          langs.forEach((lang) => {
            const name = {
              language: lang,
              name: entry.name[lang],
            };
            names.push(name);
            this.languages.forEach((available, index) => {
              if (available.value === lang) {
                foundLangs.push(index);
              }
            });
          });
          Object.assign(edit, {names});
          const editLangs = this.languages.filter((lang, index) => {
            let found = false;
            foundLangs.forEach((i) => {
              if (index === i) {
                found = true;
              }
            });
            if (!found) {
              return lang;
            }
            return false;
          });
          Object.assign(edit, {languages: editLangs});
          if (this.hasPrice) {
            Object.assign(edit, {price: entry.price});
          }
          if (label === 'Options') {
            Object.assign(edit, {maxIncludedQuantity: Number(entry.maxIncludedQuantity)});
          }
            this.currentEdit = [edit];
        }
        this.details = true;
      },
      submitEdit() {
        const target = this.currentTarget;
        const result = [];
        let err = false;
        this.currentEdit.forEach((current) => {
          const edit = {};
          edit.name = {};
          if (current.price === '' && this.hasPrice) {
            this.err = 'You must enter a price for each item.';
            err = true;
          }
          current.names.forEach((entry) => {
            if (entry.name === '') {
              this.err = 'You must enter a name for each language on each item.';
              err = true;
            }
            edit.name[entry.language] = entry.name;
          });
          if (current.price || current.price === 0) {
            edit.price = current.price;
          }
          if (current.isDefault) {
            edit.isDefault = current.isDefault;
          }
          if (current.maxIncludedQuantity > this.quantityOfIncludedOptions) {
            this.err = 'Included Quantity value cannot be higher than Quantity Of Included Options.';
            err = true;
          }
          edit.maxIncludedQuantity = Number(current.maxIncludedQuantity) || 0;
          if (!err) {
            result.push(edit);
          }
        });
        if (err) return;
        this[target] = result;
        this[target] = this.hasMultiple ? result : result[0];
        this.closeEdit();
        this.$forceUpdate();
      },
      submitItem(type = false) {
        this.err = '';

        const item = {};
        item['itemId'] = this.maxItemId + 1;
        if (this.name === null || Object.keys(this.name.name).length === 0) {
          if (!type) {
            this.err = 'You must enter a name for the item.';
            return;
          }
        } else {
          Object.assign(item, {name: this.name.name});
        }

        if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) {
          if (this.vatRate === null || isNaN(this.vatRate) || this.vatRate === "") {
            if (this.isItemChild) {
              // let vatRate = this.currentItemParent.vatRate;
              // Object.assign(item, { vatRate: vatRate });
            } else {
              if (!type) {
                this.err = 'You must enter a VAT rate.';
                return;
              }
            }
          } else {
            Object.assign(item, {vatRate: this.vatRate});
          }
        } else {
          Object.assign(item, {vatRate: null});
        }

        if (this.sizes.length === 0 ||
          (this.sizes[0].name === null || Object.keys(this.sizes[0].name).length === 0)) {
          if (this.isItemChild) {
            // let sizes = this.currentItemParent.sizes;
            // Object.assign(item, {sizes: sizes});
          } else {
            if (!type) {
              // this.err = 'You must enter at least one size.';
              // return;
            }
          }
        } else {
          Object.assign(item, {sizes: this.sizes});
        }
        if (this.styles.length === 0 ||
          (this.styles[0].name === null || Object.keys(this.styles[0].name).length === 0)) {
          if (this.isItemChild) {
            // let styles = this.currentItemParent.styles;
            // Object.assign(item, {styles: styles});
          } else {
            if (!type) {
              // this.err = 'You must enter at least one style.';
              // return;
            }
          }
        } else {
          Object.assign(item, {styles: this.styles});
        }
        if (this.options.length !== 0 &&
          (this.options[0].name !== null && Object.keys(this.options[0].name).length !== 0)) {
          Object.assign(item, {options: this.options});
        }
        if (this.options.length !== 0 &&
          (this.options[0].name !== null && Object.keys(this.options[0].name).length !== 0)) {
          Object.assign(item, {options: this.options});
        }
        if (this.variants.length !== 0 &&
          (this.variants[0].name !== null && Object.keys(this.variants[0].name).length !== 0)) {
          Object.assign(item, {variants: this.variants});
        } else {
          if (this.isItemChild) {
            if (this.currentItemParent.variants && this.currentItemParent.variants.length > 0) {
              // let variants = this.currentItemParent.variants;
              // Object.assign(item, {variants: variants});
            } else {
              if (!type) {
                // this.err = 'You must enter at least one variant.';
                // return;
              }
            }
          } else {
            if (this.pickedItem && !this.pickedItem.items) {
              if (!type) {
                // this.err = 'You must enter at least one variant.';
                // return;
              }
            } else {
              Object.assign(item, {variants: this.variants});
            }
          }
        }
        if (this.abbr !== null && Object.keys(this.abbr.name).length !== 0) {
          Object.assign(item, {abbr: this.abbr.name});
        }
        if (this.desc !== null && Object.keys(this.desc.name).length !== 0) {
          Object.assign(item, {desc: this.desc.name});
        }
        if (!this.selectedViews || this.selectedViews === null || this.selectedViews.length === 0) {
          this.err = 'You must enter at least one view'
          return;
        }

        const settings = {
          askDetails: this.askDetails,
          labelPrint: this.labelPrint,
        };
        // !!! PART FOR EDIT !!!
        if (this.pickedItem !== null && this.currentItemEvent === 'edit') {
          const pickedItem = this.pickedItem;
          pickedItem['name'] = this.name['name'];
          pickedItem['abbr'] = this.abbr !== null ? this.abbr['name'] : null;
          pickedItem['desc'] = this.desc !== null ? this.desc['name'] : null;
          if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) {
            pickedItem['vatRate'] = this.vatRate;
          } else {
            pickedItem['vatRate'] = null;
          }
          pickedItem['colorCode'] = this.color;
          pickedItem['courseNo'] = Number(this.courseNo);
          pickedItem['sizes'] = this.sizes || [];
          pickedItem['options'] = this.options || [];
          pickedItem['styles'] = this.styles || [];
          pickedItem['variants'] = this.variants || [];
          pickedItem['views'] = this.selectedViews || [];
          pickedItem['allergens'] = this.selectedAllergens || [];
          pickedItem['settings'] = {
            labelPrint: this.labelPrint,
            askDetails: this.askDetails,
          };
          pickedItem['quantityOfIncludedOptions'] = Number(this.quantityOfIncludedOptions);
          pickedItem['vatPrint'] = this.vatPrint;
          pickedItem['noDiscount'] = this.noDiscount;
          pickedItem['galaxyCardBalance'] = this.galaxyCardBalance;
          pickedItem['taxCategory'] = this.taxCategory;
          pickedItem['images'] = this.images;

          pickedItem["printerCategories"] = this.selectedPrinters;
          if (this.currentItemParent) {
            pickedItem["parentItem"] = {...this.currentItemParent, items: null};
          }
          //Parent Change For This Item
          if (pickedItem.items && pickedItem.items.length > 0) {
            pickedItem['items'] = pickedItem['items'].map((item) => {
              return {
                ...item,
                parentItem: {...pickedItem, items: null}
              }
            })
          }
        }
        // END FOR EDIT
        if (this.currentItemParent) {
          Object.assign(item, {parentItem: {...this.currentItemParent, items: null}})
        }
        Object.assign(item, {settings});
        Object.assign(item, {vatPrint: this.vatPrint});
        Object.assign(item, {noDiscount: this.noDiscount});
        Object.assign(item, {galaxyCardBalance: this.galaxyCardBalance});
        Object.assign(item, {printerCategories: this.selectedPrinters});
        Object.assign(item, {views: this.selectedViews});
        Object.assign(item, {allergens: this.selectedAllergens});
        Object.assign(item, {selected: false});
        Object.assign(item, {colorCode: this.color});
        Object.assign(item, {courseNo: Number(this.courseNo)});
        Object.assign(item, {taxCategory: this.taxCategory});
        Object.assign(item, {images: this.images});
        Object.assign(item, {quantityOfIncludedOptions: this.quantityOfIncludedOptions});
        if (type) {
          this.$emit('copy', item);
        } else {
          this.$emit('submit', item);
          this.$emit('close');
        }
      },
      addChildrenItem() {
        if (this.currentItemEvent === 'add' && this.actionPath) {
          let depth = this.actionPath.length;
          this.isItemChild = true;
        }
      },
      getItemParent() {
        if (this.items.length > 0 && this.currentItemEvent === 'add' && this.actionPath) {
          let depth = this.actionPath.length;
          let parentItem = this.items;
          if (depth === 1) {
            this.actionPath.map((index, i) => {
              parentItem = parentItem[index]
            })
          } else if (depth > 1) {
            let actionPath = [...this.actionPath];
            actionPath.reverse();
            actionPath.map((index, i) => {
              if (i + 1 !== depth) parentItem = parentItem[index].items
              else {
                parentItem = parentItem[index]
              }
            });
          }
          this.currentItemParent = parentItem;
          this.inheritFromParentItem(parentItem);
        } else if (this.items.length > 0 && this.currentItemEvent === 'edit' && this.actionPath) {
          let depth = this.actionPath.length;
          let parentItem = this.items;
          if (depth === 1) {
            parentItem = null;
          } else if (depth > 1) {
            let actionPath = [...this.actionPath];
            actionPath.reverse().pop();
            actionPath.map((index, i) => {
              if (i + 2 !== depth) parentItem = parentItem[index].items
              else {
                parentItem = parentItem[index]
              }
            });
          }
          this.currentItemParent = parentItem;
        }
        if (this.plusOne) {
          this.plusOneFunct();
        }
      },
      plusOneFunct() {
        if (this.currentItemParent.abbr && (this.currentItemParent.abbr['en'] || this.currentItemParent.abbr['de'])) {
          this.abbr = {
            name: this.currentItemParent.abbr
          }
        }
        if (this.currentItemParent.desc && (this.currentItemParent.desc['en'] || this.currentItemParent.desc['de'])) {
          this.desc = {
            name: this.currentItemParent.desc
          }
        }
        if ((this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) && (this.currentItemParent.vatRate || this.currentItemParent.vatRate === 0)) {
          this.vatRate = this.currentItemParent.vatRate.toString();
          if (this.isVatRateNotExist) {
            this.vatRate = null;
          }
        }
        this.sizes = this.currentItemParent.sizes || [];
        this.options = this.currentItemParent.options || [];
        this.styles = this.currentItemParent.styles || [];
        this.variants = this.currentItemParent.variants || [];
        this.selectedViews = this.currentItemParent.views || [];
        this.selectedAllergens = this.currentItemParent.allergens || [];
        this.color = this.currentItemParent.colorCode;
        this.courseNo = Number(this.currentItemParent.courseNo) || 6;
        this.taxCategory = this.currentItemParent.taxCategory || 'standard';
        if (this.currentItemParent.settings !== undefined) {
          this.askDetails = this.currentItemParent.settings.askDetails || false;
          this.labelPrint = this.currentItemParent.settings.labelPrint || false;
        }
        this.quantityOfIncludedOptions = this.currentItemParent.quantityOfIncludedOptions || 0;
        this.vatPrint = this.currentItemParent.vatPrint || false;
        this.noDiscount = this.currentItemParent.noDiscount || false;
        this.galaxyCardBalance = this.currentItemParent.galaxyCardBalance || false;
        this.basicImages = this.currentItemParent.images || [];
        this.fetchAllImages(this.basicImages);
        this.selectedPrinters = this.currentItemParent.printerCategories ? this.currentItemParent.printerCategories : [];
      },
      inheritFromParentItem(parentItem) {
        if ((this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) && (parentItem.vatRate || parentItem.vatRate === 0) && (parentItem.vatRate !== null)) {
          this.vatRate = parentItem.vatRate.toString();
        } else if (this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length === 0) {
          this.vatRate = null;
        }
        if (parentItem.views && parentItem.views.length > 0) {
          this.selectedViews = parentItem.views
        }
        if (parentItem.taxCategory && parentItem.taxCategory !== '') {
          this.taxCategory = parentItem.taxCategory;
        }
        if (parentItem.colorCode && parentItem.colorCode !== '') {
          this.color = parentItem.colorCode;
        }
        this.courseNo = Number(parentItem.courseNo) || 6;
        this.quantityOfIncludedOptions = parentItem.quantityOfIncludedOptions || 0;
        this.galaxyCardBalance = !!parentItem.galaxyCardBalance;
        this.noDiscount = !!parentItem.noDiscount;
        this.vatPrint = !!parentItem.vatPrint;
        if (parentItem.settings !== undefined) {
          this.askDetails = !!parentItem.settings.askDetails;
          this.labelPrint = !!parentItem.settings.labelPrint;
        }
      },
      getAllParentPrinters() {
        if (this.actionPath && this.actionPath.length > 1) {
          let depth = this.actionPath.length;
          const tempActionPath = [...this.actionPath].reverse();
          let tempItems = JSON.parse(JSON.stringify(this.items));
          for (let i = 0; i < depth; i += 1) {
            if (tempItems[tempActionPath[i]].printerCategories) {
              this.inheritSelectedPrinters = this.inheritSelectedPrinters.concat(tempItems[tempActionPath[i]].printerCategories);
            }
            tempItems = tempItems[tempActionPath[i]].items;
          }
          this.inheritSelectedPrinters = this.inheritSelectedPrinters.filter(this.onlyUnique);
          this.cleanExistingPrinters();
        }
      },
      getAllParentAttributes(type) {
        if (this.actionPath && this.actionPath.length > 1) {
          let depth = this.actionPath.length;
          let tempActionPath = [...this.actionPath].reverse();
          let tempItems = JSON.parse(JSON.stringify(this.items));
          for (let i = 0; i < depth; i += 1) {
            if (tempItems[tempActionPath[i]] && tempItems[tempActionPath[i]][type] && tempItems[tempActionPath[i]][type].length > 0 && i !== depth - 1) {
              this.inheritSelectedAttributes[type] = this.inheritSelectedAttributes[type].concat(tempItems[tempActionPath[i]][type]);
            }
            if (tempItems[tempActionPath[i]]) {
              tempItems = tempItems[tempActionPath[i]].items;
            }
          }
          this.inheritSelectedAttributes[type] = this.inheritSelectedAttributes[type].filter((att, index) => {
            const _att = JSON.stringify(att);
            return index === this.inheritSelectedAttributes[type].findIndex(obj => {
              return JSON.stringify(obj) === _att;
            });
          });
          this.cleanExistingAttributes();
        }
      },
      renderEditableItem() {
        // !!! PART FOR EDIT !!!
        if (this.items.length > 0 && this.currentItemEvent === 'edit' && this.actionPath) {
          let depth = this.actionPath.length;
          let currentItem = this.items;
          if (depth === 1) {
            this.actionPath.map((index, i) => {
              currentItem = currentItem[index]
            })
          } else if (depth > 1) {
            let actionPath = [...this.actionPath]
            actionPath.reverse();
            actionPath.map((index, i) => {
              if (i + 1 !== depth) currentItem = currentItem[index].items
              else {
                currentItem = currentItem[index]
              }
            });
          }
          if (currentItem.name) {
            this.name = {
              name: {...currentItem.name}
            }
          }

          if (currentItem.abbr && (currentItem.abbr['en'] || currentItem.abbr['de'])) {
            this.abbr = {
              name: currentItem.abbr
            }
          }
          if (currentItem.desc && (currentItem.desc['en'] || currentItem.desc['de'])) {
            this.desc = {
              name: currentItem.desc
            }
          }
          if ((this.selectedCompanyInfo.vatRates && this.selectedCompanyInfo.vatRates.length !== 0) && (currentItem.vatRate || currentItem.vatRate === 0)) {
            this.vatRate = currentItem.vatRate.toString();
            if (this.isVatRateNotExist) {
              this.vatRate = null;
            }
          }
          // this.printerCategories = [...this.items[0]]
          this.sizes = currentItem.sizes || [];
          this.options = currentItem.options || [];
          this.styles = currentItem.styles || [];
          this.variants = currentItem.variants || [];
          this.selectedViews = currentItem.views || [];
          this.selectedAllergens = currentItem.allergens || [];
          this.color = currentItem.colorCode;
          this.courseNo = Number(currentItem.courseNo) || 6;
          this.taxCategory = currentItem.taxCategory || 'standard';
          if (currentItem.settings !== undefined) {
            this.askDetails = currentItem.settings.askDetails || false;
            this.labelPrint = currentItem.settings.labelPrint || false;
          }
          this.quantityOfIncludedOptions = currentItem.quantityOfIncludedOptions || 0;
          this.vatPrint = currentItem.vatPrint || false;
          this.noDiscount = currentItem.noDiscount || false;
          this.galaxyCardBalance = currentItem.galaxyCardBalance || false;
          this.basicImages = currentItem.images || [];
          this.fetchAllImages(this.basicImages);

          this.selectedPrinters = currentItem.printerCategories ? currentItem.printerCategories : [];
          this.pickedItem = currentItem;
        }
      },
      onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
      },
      cleanExistingPrinters() {
        this.inheritSelectedPrinters = this.inheritSelectedPrinters.filter((el) => {
          return !this.selectedPrinters.includes(el);
        });
      },
      cleanExistingAttributes() {
        this.inheritSelectedAttributes.sizes = this.inheritSelectedAttributes.sizes.filter((el) => {
          return !this.sizes.includes(el);
        });
        this.inheritSelectedAttributes.styles = this.inheritSelectedAttributes.styles.filter((el) => {
          return !this.styles.includes(el);
        });
        this.inheritSelectedAttributes.variants = this.inheritSelectedAttributes.variants.filter((el) => {
          return !this.variants.includes(el);
        });
      },
      fetchImageById() {
        this.selectedImage = {};
        this.loadingPreview = true;
        this.$http.get(`imageresource/${ this.selectedImageId }`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.loadingPreview = false;
              this.selectedImage = res.body.imageResource;
              return;
            }
            this.loadingPreview = false;
            this.err = res.body.statusText
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          })
      },
      fetchLabels() {
        this.labels = [];
        this.$http.get(`system/imageresource/fetchimageresourcelabels`)
          .then((res) => {
            if (res.body.status === 'Success') {
              this.labels = res.body.imageResourceLabels.sort();
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.err = err.body.statusText || err.body.message;
          });
      },
      fetchImagesForCompany() {
        this.loading = true;
        this.allImages = [];
        this.$http.post('imageresource', {companyId: this.selectedCompanyInfo.id})
          .then((res) => {
            if (res.body.status === 'Success') {
              this.loading = false;
              this.allImages = res.body.imageResources;
              if (this.allImages.length === 0) {
                this.loading = false;
              }
              return;
            }
            this.err = res.body.statusText;
          }, (err) => {
            this.loading = false;
            this.err = err.body.statusText || err.body.message;
          });
      },
      fetchAllImages(basicImages) {
        if (basicImages.length > 0) {
          basicImages.forEach(image => {
            this.$http.get(`imageresource/${ image.value || image.id }`)
              .then((res) => {
                if (res.body.status === 'Success') {
                  this.images.push(res.body.imageResource);
                  return;
                }
                this.err = res.body.statusText
              }, (err) => {
                this.err = err.body.statusText || err.body.message;
              })
          })
        }
      },
      preview(base64Image) {
        this.previewImage = base64Image;
      },
    },
    mounted() {
      if (this.selectedCompanyInfo && this.selectedCompanyInfo.defaultLanguage) this.$cookie.set('lang', this.selectedCompanyInfo.defaultLanguage)
    },
    created() {
      this.renderEditableItem();
      this.addChildrenItem();
      this.getItemParent();
      this.getAllParentPrinters();
      ['sizes', 'styles', 'variants'].forEach(att => this.getAllParentAttributes(att));
      this.fetchLabels();
      this.catalogViews = this.views.map((current) => {
        const view = current;
        view.selected = false;
        return view;
      });
      this.catalogAllergens = this.allergens.map((current) => {
        const allergen = current;
        allergen.selected = false;
        return allergen;
      });
      this.catalogPrinters = this.printerCategories.map((current) => {
        const printer = {
          name: current,
        };
        printer.selected = false;
        return printer;
      });
    },
  };
</script>

<style lang="scss">
  .vat {
    .v-label {
      font-size: 20px;
    }
  }

  .checkbox-wrap {
    width: 100%;

    .input-group {
      min-width: 140px;
      flex: none;
      width: auto;
      width: fit-content;
      padding: 0 32px;

      .input-group__details {
        display: none !important;
      }

      label {
        position: relative !important;
        left: 0;
        max-width: 220px;
        width: auto;
        width: fit-content;
        overflow: hidden;
      }

      .input-group__input {
        position: absolute;
        left: 0;
        top: 0;
        width: 32px;
        flex: 0;
      }

      --selection-controls {
        display: inline;
      }
    }
  }

  .err {
    font-size: 16px;
    padding: 15px;
    padding-top: 0;
  }

  .modal {
    display: block;
    background: rgba(0, 0, 0, 0.5);

    &-body {
      max-height: 80vh;
      overflow-y: auto;
    }
  }

  tbody.multiple {
    &:not(:last-child) {
      border-bottom: 2px solid rgba(0, 0, 0, 0.3);
    }
  }

  label.checkbox {
    vertical-align: middle;
    margin-bottom: 10px;
    cursor: pointer;

    span {
      display: inline-block;
      position: relative;
      width: 18px;
      height: 18px;
      border-radius: 4px;
      background-color: #ffffff;
      border: 1px solid #d0d4d9;
      vertical-align: middle;
      margin-right: 1px;

      &:before {
        content: "\E5CA";
        position: absolute;
        font-family: 'Material Icons';
        font-size: 24px;
        color: #2196F3;
        font-weight: 700;
        text-align: center;
        width: 22px;
        height: 26px;
        left: -2px;
        bottom: 0;
        margin: auto;
        transform: scale(0);
        transition: all 100ms ease-in;
      }
    }

    input {
      display: none;
    }

    &.is-checked span:before {
      transform: scale(1);
    }
  }

  .vat-rate-input {
    margin-top: 15px;
  }

  .question-block {
    margin-top: 60px;
  }

  .default-item {
    display: inline-block;
    margin-left: 20px;
  }

  .views {
    p {
      display: inline;
      text-align: left;
      color: rgba(0, 0, 0, 0.78);
      cursor: pointer;
    }

    li {
      cursor: default;

      p {
        margin: 0;
        vertical-align: middle;
        color: #333;
        cursor: default;
      }

      i {
        vertical-align: middle;
        font-size: 1.5rem;
        border-radius: 4px;
        padding: 0.5rem;
        cursor: pointer;
      }
    }
  }

  .light-text {
    color: #9e9e9e;
  }

  .underline:not(:first-of-type) {
    border-top: 2px solid #d6d6d6;
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: 90%;
    }
  }

  .color-preview {
    display: inline-block;
    margin-left: 5px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    border: 1px solid #bdbdbd;
  }

  .list-color-preview {
    max-height: 28px;
    height: 100%;
    margin: 8px 0;
  }

  .arrow_to_move {
    width: 10px;
    position: relative;
    display: inline-block;
    margin-right: 10px;

    i {
      font-size: 20px;
      display: inline;
      position: absolute;

      &:first-child {
        margin-top: -25px;
      }

      &:last-of-type {
        margin-top: -5px;
      }
    }
  }

  .pointerClass {
    cursor: pointer;
  }

  .pointerClass:hover {
    font-weight: bold;
    color: red;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// SingleItem.vue?2e9a6a90